// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/styles/style.css
// module id = 816
// module chunks = 1